import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ARROW_RIGHT_ICON, X_ICON } from 'src/app/utils/svgIcons';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from "@angular/material/icon";
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PermisosAutomatizadosService } from 'src/app/services/permisos-automatizados.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { decrypt, encrypt, FILE_EXTENSION, LAYOUTS } from 'src/app/utils/constants';
import { getS3File } from 'src/app/utils/s3';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { TreeViewComponent } from '../tree-view/tree-view.component';

@Component({
  selector: 'app-propiedades-perfil',
  templateUrl: './propiedades-perfil.component.html',
  styleUrls: ['./propiedades-perfil.component.scss']
})
export class PropiedadesPerfilComponent implements OnInit {
  @ViewChild(TreeViewComponent) treeViewComponent: TreeViewComponent;
  @ViewChild('fileInput') fileInput: ElementRef;
  
  profileForm: FormGroup;
  step: number = 1;
  permissionsList: any = [];
  selectedFunctions: any = [];
  onEditingPermissionsList: any = [];
  iconAvailableList: any = [];
  contentCorporate: any = [];
  idEditingProfile: number = null;
  onCorporateProfile: boolean = false;
  userData = JSON.parse(localStorage.getItem("usuario"));
  segmentationBySapFunctions: boolean = true;
  segmentationByExcel: boolean = false;
  employeesArrayList: any = [];
  jsonDataKey: string = null;
  titleText: string = ''
  arrayBuffer: any = [];
  jsonData : any = [];
  fileName: string = null
  modulesListByExcel : any = [];
  moduleListService : any = [];
  onValidateExcel: boolean = false
  modulesOnExcel : any = [];
  profileUpdateInfo : any = [];
  urlExcel: string = null

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private ngxService: NgxUiLoaderService,
    private permisosAutomatizados: PermisosAutomatizadosService,
    sanitizer: DomSanitizer,
    iconRegistry: MatIconRegistry, ) {
      iconRegistry.addSvgIconLiteral('icon-arrow-right', sanitizer.bypassSecurityTrustHtml(ARROW_RIGHT_ICON));
      iconRegistry.addSvgIconLiteral('icon-x', sanitizer.bypassSecurityTrustHtml(X_ICON));
   }

  ngOnInit(): void {
    let propsState = history.state
    this.initData(propsState)
  }

  initData(props: any) {
    //CREANDO PERFIL
    if(props.item === 0) {
      this.idEditingProfile = null;
      this.onEditingPermissionsList = null;
      this.profileForm = new FormGroup({
        'name': new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
        'functions': new FormControl(this.selectedFunctions),
        'employeesArray': new FormControl('')
      }); 
    }
    //EDITANDO PERFIL
    else {
      this.idEditingProfile = props.item.idPerfil;
      this.profileUpdateInfo = props.item;
      this.profileForm = new FormGroup({
        'name': new FormControl(props.item.nombrePerfil, [Validators.required, Validators.minLength(3), Validators.maxLength(200)]),
      }); 
    }
  }

  async saveProfileChanges() {
    this.ngxService.start();
    this.onCorporateProfile = false;

    try {
      this.validateCorporatePermissions(this.permissionsList)
      console.log('ID PERFIL', this.idEditingProfile)

      //MUESTRA MODAL PERFIL CORPORATIVO
      if( this.onCorporateProfile ) {
        setTimeout(() => {
          this.ngxService.stop();
          this.modalService.open(this.contentCorporate);
        }, 700);
      }

      else {
        await this.modifyProfilePermissions()
      }

    } catch(err) {
      console.log(err);
      this.ngxService.stop();
      return this.showAlert(
        'Error al crear perfil', 
        `Lo sentimos, hubo un problema en el servicio, favor de volver a intentar.`
      )
    }
  }

  async modifyProfilePermissions() {
    //VALIDACION OBJETOS VACIOS
    if (this.selectedFunctions[0] === undefined && this.employeesArrayList[0] === undefined) {
      this.ngxService.stop();
      return this.showAlert(
        'No se han seleccionado datos', 
        `Selecciona los puestos que serán asignados a este perfil.`
      )
    }

    this.ngxService.start();
    let arrayFunctions: any = []

    if( this.selectedFunctions[0] != undefined ) {
      this.segmentationBySapFunctions = true
      arrayFunctions = this.filterFunctionsList();
    }
    /* ON EDIT ACTION KEEP URL FROM SERVICE */
    if(this.idEditingProfile != null && this.onEditingPermissionsList.url != null ) {
      this.jsonDataKey = this.onEditingPermissionsList.url
    }
    
    let object = {
      idUser: this.userData.idUsuario,
      nombrePerfil: this.profileForm.value.name,
      funciones: this.segmentationBySapFunctions ? arrayFunctions : [],
      modulos: this.permissionsList,
      idAsignacion: this.defineIdAsignacion(arrayFunctions, this.employeesArrayList),
      empleados: this.employeesArrayList,
      bucket: this.jsonDataKey != null ? environment.AWS_CONFIG.bucketTasks : null,
      url: this.jsonDataKey != null ? this.jsonDataKey : null, 
    }
    const encoded: any = await encrypt({ data: object });
    
    //EDITAR PERFIL
    if(this.idEditingProfile != null) {
      const result: any = await this.permisosAutomatizados.updateProfile({ data: encoded.data}, this.idEditingProfile);
      const decoded: any = await decrypt({ data: result.data });
      let response: any = decoded.data
      
      if( response.code === 200 ) { 
        this.ngxService.stop();
        Swal.fire({
          title: "Perfil actualizado con éxito",
          icon: "success",
          confirmButtonText: '<span style="color: #ffffff"> Entendido </span>',
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.changeView('perfilado-empleados')
          }
        })
      }
      else {
        this.ngxService.stop();
        return this.showAlert('Algo salió mal', `Espere unos segundos y vuelva a intentar por favor.`)
      }
    }

    //CREAR PERFIL
    else {
      const result: any = await this.permisosAutomatizados.addProfile({ data: encoded.data});
      const decoded: any = await decrypt({ data: result.data });
      let response: any = decoded.data
      
      if( response.code === 200 ) { 
        this.ngxService.stop();
        Swal.fire({
          title: "Perfil asignado con éxito",
          icon: "success",
          confirmButtonText: '<span style="color: #ffffff;"> Entendido </span>',
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.changeView('perfilado-empleados')
          }
        })
      }
      else {
        this.ngxService.stop();
        return this.showAlert('Algo salió mal', `Espere unos segundos y vuelva a intentar por favor.`)
      }
    }
  }

  defineIdAsignacion(functions: any, dataExcel: any) {
    //0 ASGINACION POR FUNCION, 1 ASIGNACION POR EXCEL, 2 AMBAS ASIGNACIONES
    if( functions[0] != undefined && dataExcel[0] != undefined) {
      return 2
    }
    if( functions[0] === undefined && dataExcel[0] != undefined) {
      return 1
    }
    if( functions[0] != undefined && dataExcel[0] === undefined) {
      return 0
    }
    else {
      return console.log('Condicion no cumplida')
    }
      
  }

  checkSegmentationType(key: any) {
    if ( key != null ) {
      return environment.AWS_CONFIG.bucketTasks
    }
    else {
      return null
    }
  }

  validateCorporatePermissions(modulos: any) {
    let corporateList: any = [158, 159, 160, 161]

    for (let i = 0; i < corporateList.length; i++) {
      modulos.forEach(element => {
        if(element == corporateList[i]){
          this.onCorporateProfile = true;
        }
      });
    }
  }

  saveContentCorporate(modal: any) {
    this.contentCorporate = modal
  }

  filterFunctionsList() {
    let functionsList: any = []

    if(this.selectedFunctions[0]) {
      this.selectedFunctions.map(element => {
        if(element.isSelected === true) {
          functionsList.push(element.idFuncion)
        }
        if(element.isSelected === undefined) {
          functionsList.push(element)
        }
      });
    }
    else {
      functionsList = this.onEditingPermissionsList.functions
    }
    return functionsList;
  }

  showAlert(title:string ,message:string){
    Swal.fire({
      title: title,
      icon:  'info',
      text:  message,
      confirmButtonColor: '#545D6E',
      confirmButtonText: '<span style="color: #ffffff"> Entendido </span>',
    })
  }

  changeView(route: string) {
    let z: any = this.userData;
    if ( route === 'perfilado-empleados'){
      this.router.navigate([`perfilado-empleados/${z.idUsuario}/${z.idCliente}`]);
    }
    else { return }
  }

  changeStep(idStep: number){
    this.step = idStep;
  }

  openModal(modalId: any){
    this.modalService.open(modalId);
  }

  onChangeTitle() {
    this.titleText = this.profileForm.value.name
  }

  async downloadFile() {
    try {
      this.ngxService.start();
      let layout: string = LAYOUTS.MODULES_LAYOUT;
      let templateName: string = 'Formato_Modulos'

      const file = await getS3File(environment.AWS_CONFIG.credentials.structureBucket, layout);
      this.saveAsExcelFile(file.Body, templateName);

    } catch (err) {
      this.ngxService.stop();
      return this.showAlert('Error en descarga', `Lo sentimos, hubo un problema en la descarga del archivo, favor de volver a intentar.`)
    }
  }
  
  saveAsExcelFile(buffer: any, name: string): void {
    try {
      const data: Blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });
      FileSaver.saveAs(data, name + '.xlsx');
      this.ngxService.stop();
    } catch (e) {
      console.log(e);
    }
  }
  
  async dropAttachFiles($event: any) {
    $event.preventDefault();
    const files = $event.dataTransfer ? $event.dataTransfer.files : $event.target.files;
    let file_name : string = ""

    for (let i = 0; i < files.length; i++) {
      file_name = files[i].name.split(/\.(?=[^\.]+$)/);
      const type = this.validateExtension(file_name[1]);
      if (type !== 'application/vnd.ms-excel') {
        const msgError = `Solo se permiten archivos formato Excel (.XLSX)`;
        return this.showAlert('Error al subir el archivo', msgError);
      }
      if (type) {
        if ((files[i].size * 0.000001) < 15) {
          this.readExcel($event.dataTransfer ? $event.dataTransfer.files[0] : $event.target.files[0])

        } else {
          const msg = `La longitud del archivo ${files[i].name} excede los límites permitidos. (15 MB)`;
          return this.showAlert('Error al subir el archivo', msg);
        }
      }
    }
  }

    
  validateExtension(extension: string) {
    extension = extension.toLowerCase();
    if (extension === FILE_EXTENSION.JPEG || extension === FILE_EXTENSION.JPG || extension === FILE_EXTENSION.PNG) {
      return 'image/*';
    }
    if (extension === FILE_EXTENSION.PDF) {
      return 'application/pdf';
    }
    if (extension === FILE_EXTENSION.MP3) {
      return 'audio/*';
    }
    if (extension === FILE_EXTENSION.XLSX || extension === FILE_EXTENSION.XLSM) {
      return 'application/vnd.ms-excel';
    }
    if (extension === FILE_EXTENSION.MP4) {
      return 'video/mp4';
    } else {
      return false;
    }
  }
  
  readExcel(file: any) {
    try {
      this.ngxService.start();

      setTimeout(async ()=> {
        const readFilePromise = new Promise((resolve,reject)=>{
          const fileReader = new FileReader();
          fileReader.onload = e => {
            this.arrayBuffer = fileReader.result;
            const data = new Uint8Array(this.arrayBuffer);
            const arr = new Array();
            for (let i = 0; i !== data.length; i++){
              arr[i] = String.fromCharCode(data[i]);
            }
            const bstr = arr.join('');
            const workbook = XLSX.read(bstr,{type:'binary'});
            const first_sheet_name = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[first_sheet_name];

            resolve(XLSX.utils.sheet_to_json(worksheet,{raw:true}));
          };
          this.fileName = file.name;
          fileReader.readAsArrayBuffer(file);
        });
        this.jsonData = await readFilePromise;
        this.modulesOnExcel = []

        this.jsonData.forEach( module => {
          this.moduleListService.map( sub => {
            if ( sub.idPermission == module['ID MODULO'] ) {
              this.modulesListByExcel.push({ 
                name: sub.item,
                urlIdPermission: sub.urlIdPermission,
                idPermission: sub.idPermission,
              })
              /* Insertar idPermissionModule a variable permissionsList */
              const validation = this.permissionsList.includes(sub.idPermissionModule)
              
              if( !validation ) {
                this.permissionsList.push(sub.idPermissionModule)
                this.modulesOnExcel.push(sub.idPermissionModule)
                this.treeViewComponent.updateModulesByExcel(this.permissionsList, sub.idPermissionModule)
              }
            }
          }); 
        }); 
        if (this.modulesListByExcel.length == 0) {
          this.ngxService.stop() 
          return this.showAlert('Sin módulos válidos', `No se encontraron módulos válidos en el archivo.`)
        }
        this.onValidateExcel = true
        this.ngxService.stop() 

      },500)

    } catch (error) {
      console.log(error);
      this.ngxService.stop()
      return this.showAlert('Error al subir el archivo', `Lo sentimos, hubo un problema al subir archivo, favor de volver a intentar.`)
    }
  }

  cleanFile() {
    this.modulesListByExcel = []
    this.onValidateExcel = false
    this.fileName = null
    this.fileInput.nativeElement.value = null;

    this.modulesOnExcel.forEach(id => {
    
      //Remove idPermissionModule from permissionsList
      function remEt(a, ele) {
        a.forEach((item, index) => {
            if (item === ele) {
                a.splice(index, 1);
            }
        });
        return a;
      }

      // call function
      remEt(this.permissionsList, id);

      // Update treeComponent 
      this.treeViewComponent.updateModulesByExcel(this.permissionsList, id) 
    });    
  }

}

